import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'slnk-shared-checkbox-validator',
  templateUrl: './shared-checkbox-validator.component.html',
  styleUrls: ['./shared-checkbox-validator.component.scss'],
  standalone: false
})
export class SharedCheckboxValidatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
